// src/cmps/comment/CommentEdit.jsx
import { useState } from 'react'
import PropTypes from 'prop-types'

export function CommentEdit({ initialContent = '', onSave, onCancel }) {
  const [content, setContent] = useState(initialContent)

  function handleSave() {
    if (content.trim()) {
      onSave(content)
    }
  }

  return (
    <div className="p-4 bg-gray-800 text-white rounded-lg shadow-md border border-gray-700">
      <textarea
        aria-label="Edit your comment"
        className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none resize-none bg-gray-900 text-white border-gray-600"
        rows={4}
        value={content}
        onChange={(e) => setContent(e.target.value)}
        placeholder="הקלד את התגובה..."
      ></textarea>
      <div className="mt-3 flex justify-end space-x-2">
        <button
          onClick={onCancel}
          className="px-4 py-2 bg-gray-700 text-white rounded hover:bg-gray-600 transition-colors"
        >
          ביטול
        </button>
        <button
          onClick={handleSave}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors disabled:opacity-50"
          disabled={!content.trim()}
        >
          שמור
        </button>
      </div>
    </div>
  )
}

CommentEdit.propTypes = {
  initialContent: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}
